<template>
  <div class="animated fadeIn mt-5" v-if="dataLoaded">
    <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event, false)">
      <div class="row">
        <b-col md="6">
          <b-card>
            <div slot="header">
              <strong>Item</strong>
            </div>

            <b-form-group label="DSR">
              <b-form-input v-model="item.dsr_name" readonly />
            </b-form-group>

            <b-form-group label="Username">
              <b-form-input v-model="item.dsr_username" readonly />
            </b-form-group>

            <b-form-group label="Ano">
              <b-form-input v-model="item.year" readonly />
            </b-form-group>

            <b-form-group label="Recibo">
              <b-form-input v-model="item.receipt_number" readonly />
            </b-form-group>

            <b-form-group label="">
              <a :href="item.image" target="_blank" size="sm" class="btn btn-primary">
                <i class="fa fa-image"></i> Ver Recibo
              </a>
            </b-form-group>

            <b-form-group label="Estado">
              <b-form-select v-model="item.status_id" :options="statusOptions" :disabled="!canEdit" />
            </b-form-group>

            <b-form-group label="Mensagem">
              <b-form-textarea rows="4" v-model="item.message" :disabled="!canEdit" />
            </b-form-group>


            <div slot="footer">
              <div class="row">
                <div class="col-sm-3">
                  <router-link :to="{ name: 'isolated/submitted.index' }" size="sm" variant="danger"><i
                      class="fa fa-ban"></i>
                    Cancelar</router-link>

                </div>
                <div class="col-sm-9 text-right">
                  <b-button type="submit" size="sm" variant="primary" :disabled="!canEdit"><i class="fa fa-save"></i>
                    Gravar</b-button>
                  <b-button type="button" v-on:click="validateBeforeSubmit($event, true)" size="sm" variant="primary"
                    :disabled="!canEdit"><i class="fa fa-save"></i> Gravar e fechar</b-button>
                </div>
              </div>
            </div>
          </b-card>


        </b-col>
      </div>
    </form>

  </div>
</template>

<script>

import Zones from '@/views/dealers/zones/modal.vue'
export default {
  name: 'BestofDsrObjectiveEdit',
  props: ['id'],
  components: { Zones },
  data() {
    return {
      originalStatusId: null,
      dataLoaded: false,
      modalType: '',
      showModal: false,
      item: {
        id: null,
        year: '',
        dsr_name: '',
        dsr_username: '',
        receipt_number: '',
        image: '',
        status_id: null,
        message: ''
      },
      statusOptions: [
        { value: 1, text: 'Em Aprovação' },
        { value: 2, text: 'Aprovado' },
        { value: 3, text: 'Rejeitado' },
        { value: 4, text: 'Substituído' }
      ]
    }
  },
  computed: {
    canEdit() {
      return this.originalStatusId !== 1 && this.originalStatusId !== 4
    }
  },
  watch: {
    'item.status_id'(newStatus) {

      const defaults = {
        1: '',
        2: 'Submissão aprovada.',
        3: 'Submissão rejeitada.',
        4: 'Submissão substituída por uma nova.'
      }

      const previousDefaults = Object.values(defaults)

      if (
        this.item.message === '' ||
        previousDefaults.includes(this.item.message)
      ) {
        this.item.message = defaults[newStatus]
      }
    }
  },
  methods: {
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {

      e.preventDefault()

      this.axios.put(
        'isolated/submitted/' + this.item.id,
        {
          status_id: this.item.status_id,
          message: this.item.message
        }
      )
        .then(response => {
          this.item = response.data.data
          this.originalStatusId = this.item.status_id

          this.$bvToast.toast(
            'Item gravado com sucesso',
            {
              autoHideDelay: 5000,
              variant: 'success',
              solid: true
            }
          )

          if (close) {
            this.$router.push({
              name: 'submitted.index'
            })
          }
        })
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get('isolated/submitted/' + id)
        .then(response => {
          this.item = response.data.data
          this.originalStatusId = this.item.status_id
          this.dataLoaded = true
        })
        .catch(response => {
          this.$bvToast.toast(`Este item não existe`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          this.$router.push({
            name: 'isolated/submitted.index'
          })
        })
    } else {
      this.dataLoaded = true
    }
  }
}
</script>
